import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RoadFillCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M20.461 22 16.254 2h-4.087l.048 1.65h-1.409L10.854 2H6.782L2.5 22h7.774l.14-4.806h2.194l.14 4.806zM10.753 5.495l-.064 2.185h1.643l-.064-2.185zm-.14 4.806h1.795l.09 3.107h-1.975z", clipRule: "evenodd" })));
}
const RoadFillCustom = forwardRef(_RoadFillCustom);
export { RoadFillCustom };
